import { cond, isNil, T, inc } from 'ramda'

/**
 * Used in infinite scrolling situations where at the start
 * the `page` is "null" and so page 0 should be requested and
 * then should just be incremented from it's current value.
 * @param {number|null} page The current page number, or null for first page
 * @returns A function that can be called with a number or null
 */
export const getCurrentPage = cond([
  [isNil, () => 0],
  [T, inc],
])
